export default __webpack_public_path__ + "static/media/DNo.26-1.163d8983.jpg";